<template>
	<div id="detail-overlay" :class="{ display: display, 'night-mode': nightMode }" v-if="currentSong">
		<div v-if="false" id="song-settings-opener" @click="toggleHideChords"><IconAngleDoubleLeft/></div>
		<div id="font-sizer" @click="toggleFontSize"><span>A</span><span>A</span></div>
		<div id="chord-switcher" @click="toggleHideChords"><span>C</span><span>dur</span></div>
		<div id="layout-switcher" @click="toggleLayout">
			<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
				 viewBox="0 0 35 35" xml:space="preserve">
				<path d="M0,0v35h35V0H0z M33,33H2V2h31V33z"/>
				<rect x="4.5" y="4.5" width="11.5" height="26"/>
				<rect x="19" y="4.5" width="11.5" height="26"/>
			</svg>

		</div>
		<div id="export-song-button" @click="exportSong" v-if="isCurrentSongInUserSongs">PDF</div>
		<div id="print-song-button" @click="printSong" v-if="isPossibleToPrint && isCurrentSongInUserSongs"><IconPrint /></div>
		<div id="session-transposition-buttons" v-if="isInSession">
			<div class="session-transposition-button" @click="$emit('transpose', -1)">-</div>
			<div class="session-transposition-button" @click="$emit('transpose', +1)">+</div>
		</div>
		<div id="scroller" :class="{ 'need-scroller': needScroller }" v-if="isCurrentSongInUserSongs">
			<i @click="playPause" v-if="currentSong.duration">
				<IconPlay v-if="!detailScrolling" />
				<IconPause v-if="detailScrolling" />
			</i>
			<span v-if="currentSong.duration">{{ scrollerTimer }}</span>
			<span v-if="currentSong.duration === null || currentSong.duration === undefined" class="helper">{{ $t('song.scrolling') }}</span>
			<input type="range" min="60" max="420" step="15" v-model="currentSong.duration" @change="scrollerChange">
		</div>
	</div>
</template>

<script>
	import IconAngleDoubleLeft from "@/components/icons/IconAngleDoubleLeft";
	import Vue from "vue";
	import { mapState } from "vuex";
	import { SongService } from "@/services/SongService";
	import IconPlay from "@/components/icons/IconPlay";
	import IconPause from "@/components/icons/IconPause";
	import IconPrint from "../icons/IconPrint";
	import { Browser } from "@capacitor/browser";

	export default {
		name: "DetailOverlay",
		components: {IconPrint, IconPause, IconPlay, IconAngleDoubleLeft },
		data() {
			return {
				display: false,
				displayTimeout: null
			}
		},
		props: {
			currentSong: [ Object, null ],
			isInSession: {
				type: Boolean,
				default: false
			}
		},
		recomputed: {
			needScroller() {
				var viewportElement = document.getElementById("detail-scroll");
				if (viewportElement === null || viewportElement === undefined) return true;

				var songElement = viewportElement.getElementsByClassName("song-content")[0];
				if (songElement === null || songElement === undefined) return true;

				return viewportElement.offsetHeight < (songElement.offsetHeight + 310);
			}
		},
		computed: {
			...mapState([ "detailFontSize", "detailHideChords", "detailScrolling", "songs", "nightMode", "device" ]),
			scrollerTimer() {
				if (this.currentSong.duration === null || this.currentSong.duration === undefined) return "";
				return (Math.floor(this.currentSong.duration / 60)) + ":" + (this.currentSong.duration % 60).toString().padStart(2, "0");
			},
			isCurrentSongInUserSongs() {
				return "songId" in this.currentSong && this.currentSong.songId in this.songs;
			},
			isPossibleToPrint() {
				return typeof window.print === "function" && this.device.platform === "web" && !this.isElectron;
			},
			isElectron() {
				return navigator.userAgent.toLowerCase().indexOf(' electron/') > -1;
			}
		},
		watch: {
			currentSong()  {
				this.$recompute("needScroller");
			}
		},
		methods: {
			exportSong() {
				const url = `https://server.mangozpevnik.cz/songExport/${this.currentSong.id}.pdf`;
				if (window.todesktop) {
					window.todesktop.contents.openUrlInBrowser(url);
				} else {
					Browser.open({ url: url });
				}
			},
			printSong() {
				try {
					document.execCommand("print", false, null) // for Safari
				} catch {
					window.print()
				}
			},
			toggleLayout() {
				const key = "songs:" + this.currentSong.id + ":twoColumns";
				const value = localStorage.getItem(key);
				if (value === null) {
					localStorage.setItem(key, true);
				} else {
					localStorage.removeItem(key);
				}
				this.$emit("layout-changed");
			},
			toggleFontSize() {
				const sizes = [ 0.6, 0.8, 1.1, 1.3, 1.5, 1.7, 1.9 ];
				var index = sizes.indexOf(this.detailFontSize) + 1;
				this.$store.commit("setDetailFontSize", index in sizes ? sizes[index] : sizes[0]);
				Vue.nextTick(() => {
					document.dispatchEvent(new Event("ProcessChords"));
				});
			},
			toggleHideChords() {
				this.$store.commit("setDetailHideChords", !this.detailHideChords);
				Vue.nextTick(() => {
					document.dispatchEvent(new Event("ProcessChords"));
				});
			},
			playPause() {
				this.$store.commit("setDetailScrolling", !this.detailScrolling);

				if (this.detailScrolling) {
					document.dispatchEvent(new Event("StartScrolling"));
				} else {
					document.dispatchEvent(new Event("StopScrolling"));
				}
			},
			stopScrolling() {
				this.$store.commit("setDetailScrolling", false);
			},
			show(e) {
				e.stopPropagation();
				if (this.displayTimeout !== null) clearTimeout(this.displayTimeout);
				setTimeout(() => { this.display = true }, 100);
				this.displayTimeout = setTimeout(() => { this.display = false }, 3000);
			},
			scrollerChange(e) {
				this.$store.commit("setDetailScrolling", true);
				e.preventDefault();
				e.stopPropagation();
				SongService.setSongDuration(this.currentSong);
				document.dispatchEvent(new Event("UpdateScrolling"));
			},
			orientationChanged() {
				setTimeout(() => {
					this.$recompute("needScroller");
				}, 1000);
			}
		},
		mounted() {
			document.addEventListener("ShowDetailOverlay", this.show);
			document.addEventListener("StopScrolling", this.stopScrolling);

			this.$el.addEventListener("click", this.show);
			this.$el.addEventListener("touchstart", this.show);
			this.$el.addEventListener("touchmove", this.show);
			this.$el.addEventListener("touchend", this.show);
			this.$el.addEventListener("mousemove", this.show);

			window.addEventListener("orientationchange", this.orientationChanged);
		},
		destroyed() {
			document.removeEventListener("ShowDetailOverlay", this.show);
			document.removeEventListener("StopScrolling", this.stopScrolling);

			this.$el.removeEventListener("click", this.show);
			this.$el.removeEventListener("touchstart", this.show);
			this.$el.removeEventListener("touchmove", this.show);
			this.$el.removeEventListener("touchend", this.show);
			this.$el.removeEventListener("mousemove", this.show);

			window.removeEventListener("orientationchange", this.orientationChanged);
		}
	}
</script>

<style lang="scss" scoped>
	@media only screen and (max-width: 650px) {
		.side-opened #detail-overlay {
			opacity: 0 !important;
			visibility: hidden !important;
		}
	}

	#detail-overlay {
		opacity: 0;
		visibility: hidden;
		transition: opacity 500ms, visibility 500ms;

		&.night-mode {
			#chord-switcher {
				background-color: black !important;
			}

			#font-sizer {
				background-color: black !important;
			}

			#layout-switcher {
				background-color: black !important;
				svg {
					fill: rgba(255, 255, 255, 0.7);
				}
			}

			#export-song-button {
				background-color: black !important;
			}

			#print-song-button {
				background-color: black !important;
				svg {
					fill: rgba(255, 255, 255, 0.7);
				}
			}

			#scroller {
				background-color: black !important;

				.icon {
					fill: white;
				}
			}
		}
	}

	#detail-overlay.display {
		opacity: 1;
		visibility: visible;
	}

	#song-settings-opener {
		z-index: 2300;
		position: fixed;
		top: 0;
		right: 20px;
		background-color: rgb(255, 255, 255);
		padding: 2px 8px;
		border-radius: 4px;
		cursor: pointer;

		&:hover {
			opacity: 1;
		}

		span:nth-child(1) {
			font-size: 2em;
		}

		span:nth-child(2) {
			font-size: 1.2em;
		}
	}

	#font-sizer {
		z-index: 2300;
		position: fixed;
		top: 110px;
		right: 20px;
		background-color: rgb(255, 255, 255);
		padding: 2px 8px;
		border-radius: 4px;
		cursor: pointer;
		box-shadow: rgba(0, 0, 0, 0.10) 4px 4px 12px;

		&:hover {
			opacity: 1;
		}

		span:nth-child(1) {
			font-size: 2em;
		}

		span:nth-child(2) {
			font-size: 1.2em;
		}
	}

	#chord-switcher {
		z-index: 2300;
		position: fixed;
		top: 160px;
		right: 20px;
		background-color: rgb(255, 255, 255);
		padding: 2px 8px;
		border-radius: 4px;
		cursor: pointer;
		box-shadow: rgba(0, 0, 0, 0.10) 4px 4px 12px;

		&:hover {
			opacity: 1;
		}

		span:nth-child(1) {
			font-size: 1.5em;
		}

		span:nth-child(2) {
			font-size: 1em;
		}
	}

	#layout-switcher {
		z-index: 2300;
		position: fixed;
		top: 202px;
		right: 20px;
		background-color: rgb(255, 255, 255);
		padding: 2px 8px;
		border-radius: 4px;
		cursor: pointer;
		box-shadow: rgba(0, 0, 0, 0.10) 4px 4px 12px;

		&:hover {
			opacity: 1;
		}

		svg {
			margin: 8px 2px 4px 2px;
			height: 32px;
		}
	}

	#export-song-button {
		z-index: 2300;
		position: fixed;
		top: 263px;
		right: 20px;
		background-color: rgb(255, 255, 255);
		padding: 2px 8px;
		border-radius: 4px;
		cursor: pointer;
		box-shadow: rgba(0, 0, 0, 0.10) 4px 4px 12px;

		&:hover {
			opacity: 1;
		}

		svg {
			margin: 8px 2px 4px 2px;
			height: 32px;
		}
	}

	#print-song-button {
		z-index: 2300;
		position: fixed;
		top: 295px;
		right: 20px;
		background-color: rgb(255, 255, 255);
		padding: 2px 8px;
		border-radius: 4px;
		cursor: pointer;
		box-shadow: rgba(0, 0, 0, 0.10) 4px 4px 12px;

		&:hover {
			opacity: 1;
		}

		svg {
			margin: 8px 2px 4px 2px;
			height: 32px;
		}
	}

	#session-transposition-buttons {
		z-index: 2300;
		position: fixed;
		top: 358px;
		right: 20px;
		display: flex;
		flex-direction: row;
		gap: 16px;

		.session-transposition-button {
			background-color: rgb(255, 255, 255);
			padding: 8px 16px;
			border-radius: 4px;
			cursor: pointer;
			font-size: 20px;
			box-shadow: rgba(0, 0, 0, 0.10) 4px 4px 12px;

			&:hover {
				opacity: 1;
			}
		}
	}

	#scroller {
		z-index: 2300;
		position: fixed;
		bottom: 20px;
		width: 240px;
		background-color: rgb(255, 255, 255);
		padding: 10px 20px;
		border-radius: 4px;
		opacity: 0;
		box-shadow: rgba(0, 0, 0, 0.10) 4px 4px 12px;

		&.need-scroller {
			opacity: inherit;
		}

		.icon {
			float: left;
			width: 22px;
			margin-right: 15px;
			opacity: 0.7;
			cursor: pointer;
		}

		.icon:hover {
			opacity: 1;
		}

		input {
			float: left;
			-webkit-appearance: none;
			appearance: none;
			width: 150px;
			height: 15px;
			margin-top: 6px;
			background: rgba(211, 211, 211, 0.5);
			outline: none;
			border-radius: 8px;
		}

		input::-webkit-slider-thumb {
			-webkit-appearance: none; /* Override default look */
			appearance: none;
			width: 25px;
			height: 25px;
			background: #ef904e;
			cursor: pointer;
			border-radius: 16px;
		}

		input::-moz-range-thumb {
			width: 25px;
			height: 25px;
			background: #ef904e;
			cursor: pointer;
			border-radius: 16px;
		}

		input::-moz-range-thumb:hover {
			box-shadow: rgba(0, 0, 0, 0.15) 0 0 12px;
		}

		span {
			width: 50px;
			float: left;
			display: block;
			margin-top: 5px;
			height: 24px;

			&.helper {
				width: 87px;
			}
		}

	}
</style>
